export default __webpack_public_path__ + "static/media/tstorms.6604fb82.svg";